import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";

type UseQueryPaymentStatusArgs = {
  paymentItemId: string;
  enabled?: boolean;
  authorisation: string;
};

export function useQueryPaymentStatus({
  paymentItemId,
  enabled = true,
  authorisation,
}: UseQueryPaymentStatusArgs) {
  return useQuery(
    ["paymentStatus", paymentItemId],
    async () => {
      return await httpClient(`payment/pay/${paymentItemId}`, {
        authorisation,
        headers: { Accept: "application/json" },
      }).get();
    },
    {
      enabled: enabled && !!paymentItemId,
      refetchInterval: (data: any) => {
        const raw = (data?.status || data?.data?.status || "")
          .toString()
          .toUpperCase();
        return raw === "PENDING" || raw === "PROCESSING" ? 3000 : false;
      },

      retry: 1,
    }
  );
}
